import React from 'react'
import Booking  from '../components/Booking'
import NavUser from '../components/NavUser'
function HotelBooking() {
  return (
    <div>
      <NavUser/>
      <Booking/>
    </div>
  )
}

export default HotelBooking